export default __webpack_public_path__ + "static/media/CimmerianCampMap.f891ee28.jpg";